<template>
    <div class="fancy-info-i">
      <div class="fancy-info-i__icon">i</div>
      <div class="fancy-info-i__text" v-html="text"></div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      text: {
        type: String,
        default: null,
      },
    },
    methods: {},
  };
  </script>